export default "__VITE_ASSET__Dfg7aSs2__"